import axios from 'axios'

const RESOURCE_NAME = '/anaf'

export default {
    getCompanyDetails (cif) {
        return axios.post(`${RESOURCE_NAME}/data?cif=${cif}`);
    }
}